// src/data/twoStep.js - RULING 303 (D4, ruling 278 item 4; ruling 214). Pure - no Firebase import - so
// scripts\test-two-step.mjs can hold it. Who is offered authenticator-app two-step sign-in, and the plain words for
// each failure the enrolment and sign-in steps can meet.
export const TWO_STEP_ISSUER = 'Labor On The Record';

// Ruling 278 item 4 names the administrator, General Chairpersons and Local Chairpersons. Members are not offered it
// in this phase; nobody is REQUIRED to use it until Bob has enrolled first (ruling 303).
export function mayEnrollTwoStep(user) {
  if (!user) return false;
  return !!(user.isAdmin || user.role === 'admin' || user.role === 'general_chair' || user.role === 'local_chair'
    || user.role === 'gc_onboarding');   // Record 675: he uploads his members' records
}

// A code is exactly six digits once spaces are taken out (authenticator apps often show "123 456").
export function cleanCode(raw) {
  const s = String(raw || '').replace(/\s+/g, '');
  return /^\d{6}$/.test(s) ? s : '';
}

export function twoStepError(code) {
  switch (code) {
    case 'auth/invalid-verification-code':
      return "That code didn't match. Use the newest code your app shows, and check that the phone's clock is set automatically.";
    case 'auth/requires-recent-login':
      return 'For your protection this needs a fresh sign-in. Sign out, sign back in, and start again.';
    case 'auth/too-many-requests':
      return 'Too many tries. Wait a few minutes and try again.';
    case 'auth/network-request-failed':
      return 'No connection to the sign-in service. Check the network and try again.';
    case 'auth/missing-code':
      return 'Enter the six-digit code from your authenticator app.';
    default:
      return 'Two-step sign-in failed (' + (code || 'unknown error') + ').';
  }
}
